import { BOPatientFarmacologicRecord} from '../BOPatientFarmacologicRecord.model'



export class BOTranspFarmacologicRecords {
    PatientFarmacologicRecords:BOPatientFarmacologicRecord[]=[];
    patientId:number;
}
